const fractionUtils = (num) => {
	if (typeof num !== 'number') return;

	var formatter = new Intl.NumberFormat('sl-SL', {
		style: 'percent',
	});

	return formatter.format(num / 100);
};

export default fractionUtils;
